


import React, { useState, useEffect } from "react";
import axios from "axios";
import ShimmerLoader from "../../Components/UI-Controls/Loader/ShimmerLoader";
import { IoEyeOutline } from "react-icons/io5";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import actionIcon from "../../Assets/Images/ActionBtn 30 x 30.png";
import DataTable from "react-data-table-component";
import Pagination from "../../Components/UI-Controls/Pagination/PaginationRashid";
import CummulativeBox from "./cummulationBox";
import productImg from "../../Assets/Images/product.png"
import avaiProduct from "../../Assets/Images/total-product-2.png"
import inactProduct from "../../Assets/Images/product-inactive-1.png"
import locProduct from "../../Assets/Images/product-loc-1.png"
import { formatDate } from "../../Components/UI-Controls/DateFormat/DateFormat1";
import searchIcon from "../../Assets/Images/Search Bar 20 x 20.png";
import { formatCurrencyValue } from "../../Services/Api";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from "react-accessible-accordion";
import CustomBtn from "../../Components/UI-Controls/Buttons/Btn";
import InputField from "../../Components/UI-Controls/InputField/InputField";
import { FaHandHoldingUsd, FaTimesCircle, FaClipboardList, FaShippingFast, FaUserPlus, FaShoppingCart } from "react-icons/fa";
import CustomDropdown from "../../Components/UI-Controls/Dropdown/dropdown";

import "./style.css";
import LastActiveTimestamp from "../../Components/UI-Controls/DateFormat/LastActive";
import { format, formatDistanceToNow, isYesterday } from "date-fns";
import ElipticalPagenation from "../../Components/UI-Controls/Pagination/Pagination2";
import SearchBar from "../../Components/UI-Controls/SearchBar/Search";
import LastActivityTimestamp from "../../Components/UI-Controls/DateFormat/LastActivity";

export default function AshleyInvMatresses() {
    const [inventory, setInventory] = useState([]);
    const [filteredInventory, setFilteredInventory] = useState([]);
    const [originalData, setOriginalData] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");

    const [loading, setLoading] = useState(true);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [cummulations, setCummulations] = useState(
        {
            totalProducts: 0,
            availableProducts: 0,
            reservedProducts: 0,
            totalSelling: 0,
            activeProductsCount: 0,
            inactiveProductsCount: 0
        }
    )

    const customStyles = {
        headCells: {
            style: {
                height: "clamp(50px, 5vw, 56px)",
                background: "transparent",
                textAlign: "center",
                justifyContent: "center",
                border: "none",
                color: "var(--text-color-1)",
                fontFamily: "var(--font-family)",
                fontWeight: "var(--font-weight-medium)",
                fontSize: "clamp(var(--font-size-medium), 0.8vw, calc(var(--font-size-medium) + 2px))",
            },
        },
        cells: {
            style: {
                height: "clamp(50px, 6vw, 66px)",
                justifyContent: "center",
                textAlign: "center",
                background: "transparent",
                borderTop: "var(--standered-border)",
                borderRight: "none",
                color: "var(--text-color-1)",
                fontFamily: "var(--font-family)",
                fontWeight: "var(--font-weight-regular)",
                fontSize: "clamp(var(--font-size-small), 0.8vw, calc(var(--font-size-small) + 2px))",
            },
        },
    };

    const toggleDropdown = (id) => {
        setOpenDropdownId((prevId) => (prevId === id ? null : id));
    };

    const handleAction = (action, row) => {
        console.log(`Action: ${action} triggered for row:`, row);
        setOpenDropdownId(null); // Close dropdown on action
        // Add action logic here
    };


    async function searchProducts(query) {
        try {
            setLoading(true);
            const response = await axios.get(
                `https://syncinventory.myfurnituremecca.com/api/v1/product-inventory/search-by-name?query=${query}`
            );

            const data = response?.data?.entities || [];
            setFilteredInventory(data); // Sirf filter wali list update hogi
            setTotalPages(response?.data?.pagination?.totalPages || 1);
        } catch (error) {
            console.error("Error searching products:", error);
        } finally {
            setLoading(false);
        }
    }


      const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 1500);
    
      useEffect(() => {
        const handleResize = () => {
          setIsSmallScreen(window.innerWidth <= 1500);
        };
    
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);





    // const OrdersColumns = [
    //     {
    //         name: (
    //             <input
    //                 type="checkbox"
    //                 style={{ margin: 0 }}
    //                 onChange={(e) => console.log("All selected:", e.target.checked)}
    //             />
    //         ),
    //         cell: (row) =>
    //             loading ? (
    //                 <ShimmerLoader width="20px" height="20px" />
    //             ) : (
    //                 <input
    //                     type="checkbox"
    //                     style={{ margin: 0 }}
    //                     onChange={(e) => console.log("Selected:", row, e.target.checked)}
    //                 />
    //             ),
    //         ignoreRowClick: true,
    //         width: "50px",
    //     },
    //     {
    //         name: "Image",
    //         cell: (row) => (
    //             loading ? (
    //                 <ShimmerLoader width="60px" height="50px" />
    //             ) : (
    //                 <div className="p_img_1" style={{ display: "flex", alignItems: "center", gap: "5px" }}>

    //                     <img
    //                         key={row.image?._id}
    //                         src={
    //                             row?.imageSet?.length>0 && row?.imageSet[0]?.href
    //                         }
    //                         //   alt={row?.name}
    //                         height="40px"
    //                         style={{ objectFit: "cover" }}
    //                     />
    //                 </div>
    //             )
    //         ),
    //         minWidth: "100px",
    //         maxWidth: "140px",
    //     },
    //     {
    //         name: "Product Name",
    //         selector: (row) => row.itemName,
    //         minWidth: "300px",
    //         // maxWidth: "450px",
    //         cell: (row) => (
    //             loading ? (
    //                 <ShimmerLoader width="300px" height="22.5px" borderRadius="20px" />
    //             ) : (
    //                 <div style={{
    //                     whiteSpace: "normal",
    //                     overflow: "hidden",
    //                     textOverflow: "ellipsis",
    //                     display: "-webkit-box",
    //                     WebkitLineClamp: 2,
    //                     WebkitBoxOrient: "vertical",
    //                     WebkitLineClamp: 2,
    //                 }}>
    //                     {row.itemName}
    //                 </div>
    //             )),
    //     },
    //     {
    //         name: "SKU",
    //         selector: (row) => row.sku,
    //         cell: (row) =>
    //             loading ? (
    //                 <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
    //             ) : (
    //                 <div style={{
    //                     whiteSpace: "normal",
    //                     overflow: "hidden",
    //                     textOverflow: "ellipsis",
    //                     display: "-webkit-box",
    //                     WebkitLineClamp: 2,
    //                     WebkitBoxOrient: "vertical",
    //                     WebkitLineClamp: 2,
    //                 }}>
    //                     {row.sku}
    //                 </div>
    //             ),
    //         minWidth: "200px",
    //         maxWidth: "350px",
    //     },
    //     {
    //         name: "Sale Price",
    //         selector: (row) => row.fobBasePrice,
    //         cell: (row) =>
    //             loading ? (
    //                 <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
    //             ) : (
    //                 <div style={{
    //                     whiteSpace: "normal",
    //                     overflow: "hidden",
    //                     textOverflow: "ellipsis",
    //                     display: "-webkit-box",
    //                     WebkitLineClamp: 2,
    //                     WebkitBoxOrient: "vertical",
    //                     WebkitLineClamp: 2,
    //                 }}>
    //                     ${formatCurrencyValue(row.fobBasePrice)}
    //                 </div>
    //             ),
    //         minWidth: "120px",
    //         maxWidth: "200px",
    //     },
    //     {
    //         name: "Last Modification",
    //         selector: (row) => row.lastModifiedDateTime,
    //         cell: (row) =>
    //             loading ? (
    //                 <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
    //             ) : (() => {

    //                 if (row?.lastModifiedDateTime) {
    //                     const lastLoginAt = formatDate(row?.lastModifiedDateTime);
    //                     const now = new Date();
    //                     let displayText;

    //                     if (isYesterday(lastLoginAt)) {
    //                         displayText = `Yesterday, ${format(lastLoginAt, "h:mm a")}`;
    //                     } else if (now - lastLoginAt < 24 * 60 * 60 * 1000) {
    //                         displayText = formatDistanceToNow(lastLoginAt, { addSuffix: true });
    //                     } else {
    //                         displayText = <LastActivityTimestamp createdAt={row?.lastModifiedDateTime} />;
    //                     }

    //                     return (
    //                         <div style={{
    //                             whiteSpace: "normal",
    //                             overflow: "hidden",
    //                             textOverflow: "ellipsis",
    //                             display: "-webkit-box",
    //                             WebkitLineClamp: 2,
    //                             WebkitBoxOrient: "vertical",
    //                             maxHeight: "44px",
    //                         }}>
    //                             {displayText}
    //                         </div>
    //                     );
    //                 }
    //             })(),
    //         minWidth: "120px",
    //         maxWidth: "200px",
    //     },
    //     {
    //         name: "Status",
    //         selector: (row) => row.status,
    //         cell: (row) =>
    //             loading ? (
    //                 <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
    //             ) : (
    //                 <div style={{
    //                     whiteSpace: "normal",
    //                     overflow: "hidden",
    //                     textOverflow: "ellipsis",
    //                     display: "-webkit-box",
    //                     WebkitLineClamp: 2,
    //                     WebkitBoxOrient: "vertical",
    //                     WebkitLineClamp: 2,
    //                 }}>
    //                     {row.status === "active" ? "Active" : row.status === "notactive" ? "Inactive" : row.status}
    //                 </div>
    //             ),
    //         minWidth: "120px",
    //         maxWidth: "200px",
    //     },
    // ];

     const OrdersColumns = [
            {
                name: (
                    <input
                        type="checkbox"
                        style={{ margin: 0 }}
                        onChange={(e) => console.log("All selected:", e.target.checked)}
                    />
                ),
                cell: (row) =>
                    loading ? (
                        <ShimmerLoader width="20px" height="20px" />
                    ) : (
                        <input
                            type="checkbox"
                            style={{ margin: 0 }}
                            onChange={(e) => console.log("Selected:", row, e.target.checked)}
                        />
                    ),
                ignoreRowClick: true,
                width: "50px",
            },
            {
                name: "Image",
                cell: (row) => (
                    loading ? (
                        <ShimmerLoader width="60px" height="50px" />
                    ) : (
                        <div className="p_img_1" style={{ display: "flex", alignItems: "center", gap: "5px" }}>
    
                            <img
                                key={row.image?._id}
                                src={
                                    row?.imageSet?.length > 0 && row?.imageSet[0]?.href
                                }
                                //   alt={row?.name}
                                height="40px"
                                style={{ objectFit: "cover" }}
                            />
                        </div>
                    )
                ),
                minWidth: "100px",
                maxWidth: "140px",
            },
            {
                name: "Product Name",
                selector: (row) => row.itemName,
                minWidth: "300px",
                // maxWidth: "450px",
                cell: (row) => (
                    loading ? (
                        <ShimmerLoader width="300px" height="22.5px" borderRadius="20px" />
                    ) : (
                        <div style={{
                            whiteSpace: "normal",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                        }}>
                            {row.itemName}
                        </div>
                    )),
            },
            {
                name: "SKU",
                selector: (row) => row.sku,
                cell: (row) =>
                    loading ? (
                        <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
                    ) : (
                        <div style={{
                            whiteSpace: "normal",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                        }}>
                            {row.sku}
                        </div>
                    ),
                minWidth: "200px",
                maxWidth: "350px",
            },
            {
                name: "Color",
                selector: (row) => row.colorSwatch,
                cell: (row) =>
                    loading ? (
                        <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
                    ) : (() => {
    
                        return (
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "2px"
                            }}>
                                {row?.colorSwatch && <img style={{
                                    height: "30px",
                                    width: "30px",
                                    borderRadius: "3px",
                                    boxShadow: "rgba(99, 99, 99, 0.5) 0px 2px 8px 0px"
                                }} src={row?.colorSwatch} alt="" srcset="" />}
                                <span style={{ fontSize: "10px" }}>{row?.color}</span>
                            </div>
                        )
                        // if (row?.lastModifiedDateTime) {
                        //     const lastLoginAt = formatDate(row?.lastModifiedDateTime);
                        //     const now = new Date();
                        //     let displayText;
    
                        //     if (isYesterday(lastLoginAt)) {
                        //         displayText = `Yesterday, ${format(lastLoginAt, "h:mm a")}`;
                        //     } else if (now - lastLoginAt < 24 * 60 * 60 * 1000) {
                        //         displayText = formatDistanceToNow(lastLoginAt, { addSuffix: true });
                        //     } else {
                        //         displayText = <LastActivityTimestamp createdAt={row?.lastModifiedDateTime} />;
                        //     }
    
                        //     return (
                        //         <div style={{
                        //             whiteSpace: "normal",
                        //             overflow: "hidden",
                        //             textOverflow: "ellipsis",
                        //             display: "-webkit-box",
                        //             WebkitLineClamp: 2,
                        //             WebkitBoxOrient: "vertical",
                        //             maxHeight: "44px",
                        //         }}>
                        //             {displayText}
                        //         </div>
                        //     );
                        // }
    
                    })(),
                minWidth: "100px",
                maxWidth: "140px",
            },
          {
        name: "FOB Price",
        selector: (row) => row.fobBasePrice,
        cell: (row) =>
            loading ? (
                <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
            ) : (
                <div
                    style={{
                        display: "flex",
                        flexDirection: isSmallScreen ? "column" : "row",
                        gap: isSmallScreen ? "6px" : "0",
                        alignItems: "center",
                        justifyContent:"center",
    
                    }}
                >
                    {/* Price */}
                    <div
                        style={{
                            whiteSpace: "normal",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            fontWeight: 600,
                        }}
                    >
                        ${formatCurrencyValue(row.fobBasePrice)}
                    </div>
    
                    {/* Stock Label for Small Screen */}
                    {isSmallScreen && (() => {
                        let textColor;
                        let backgroundColor;
                        let stockLabel;
    
                        switch (row.status) {
                            case "Current":
                            case "New":
                                textColor = "#5285B4";
                                backgroundColor = "#5285B4" + "10";
                                stockLabel = "In Stock";
                                break;
                            case "Discontinued":
                                textColor = "#F08F9F";
                                backgroundColor = "#F08F9F" + "10";
                                stockLabel = "Out of Stock";
                                break;
                            default:
                                textColor = "#36454F";
                                backgroundColor = "transparent";
                                stockLabel = "Undefined";
                        }
    
                        return (
                            <div
                                style={{
                                    color: textColor,
                                    backgroundColor: backgroundColor,
                                    padding: "3px 8px",
                                    borderRadius: "5px",
                                    fontWeight: 600,
                                    fontSize: "12px",
                                    display: "inline-block",
                                }}
                            >
                                {stockLabel}
                            </div>
                        );
                    })()}
                </div>
            ),
        minWidth: "120px",
        maxWidth: "200px",
    },
    
            {
                name: "Stock",
                omit: isSmallScreen,
                cell: (row) => (
                    !loading ? (
                        (() => {
                            let textColor;
                            let backgroundColor;
                            let stockLabel;
    
                            switch (row.status) {
                                case "Current":
                                    textColor = "#5285B4";
                                    backgroundColor = "#5285B4" + "10";
                                    stockLabel = "In Stock";
                                    break;
                                case "New":
                                    textColor = "#5285B4";
                                    backgroundColor = "#5285B4" + "10";
                                    stockLabel = "In Stock";
                                    break;
                                case "Discontinued":
                                    textColor = "#F08F9F";
                                    backgroundColor = "#F08F9F" + "10";
                                    stockLabel = "Out of Stock";
                                    break;
                                default:
                                    textColor = "#36454F";
                                    backgroundColor = "transparent";
                                    stockLabel = "Undefined";
                            }
    
                            return (
                                <div
                                    style={{
                                        color: textColor,
                                        backgroundColor: backgroundColor,
                                        padding: "5px 10px 5px 10px",
                                        borderRadius: "5px",
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        fontWeight: 600,
                                    }}
                                >
                                    {stockLabel}
                                </div>
                            );
                        })()
                    ) : (
                        <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
                    )
                ),
                minWidth: "135px",
                maxWidth: "175px",
                // omit: isSmallScreen,
            },
    
            {
                name: "Status",
                selector: (row) => row.status,
                cell: (row) =>
                    loading ? (
                        <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
                    ) : (
                        <div style={{
                            whiteSpace: "normal",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                        }}>
                            {row.status === "active" ? "Active" : row.status === "notactive" ? "Inactive" : row.status}
                        </div>
                    ),
                minWidth: "120px",
                maxWidth: "200px",
                omit: isSmallScreen,
            },
        ];
    const [totalPages, setTotalPages] = useState(1);
    async function fetchData(page) {
        try {
            setLoading(true);
            const response = await axios.get(
                `https://syncinventory.myfurnituremecca.com/api/v1/product-inventory/get-ashley-inventory?category=MATTRESSESANDBEDDING&page=${page}&ExpressShip=false`
            );

            const data = response?.data?.entities || [];
            const pagenation = response?.data?.pagination;

            setInventory(data);
            setFilteredInventory(data);
            setTotalPages(pagenation?.totalPages);
            setOriginalData(data);

            console.log(inventory[0], "here")
            setLoading(false);

            // const cummulations = data.reduce(
            //     (acc, item) => {
            //         acc.totalProducts += 1;
            //         acc.availableProducts += Number(item.available) || 0;
            //         acc.reservedProducts += Number(item.reserved) || 0;
            //         acc.totalSelling += Number(item.selling_price) || 0;

            //         if (item.status === "active") {
            //             acc.activeProductsCount += 1;
            //         } else {
            //             acc.inactiveProductsCount += 1;
            //         }

            //         return acc;
            //     },
            //     {
            //         totalProducts: 0,
            //         availableProducts: 0,
            //         reservedProducts: 0,
            //         totalSelling: 0,
            //         activeProductsCount: 0,
            //         inactiveProductsCount: 0,
            //     }
            // );

             setCummulations({
                totalProducts: pagenation?.totalItems,
                availableProducts: 0,
                reservedProducts: 0,
                totalSelling: 0,
                activeProductsCount: 0,
                inactiveProductsCount: 0,
            });
        } catch (error) {
            setLoading(false);
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            searchProducts(searchTerm);
        } else {
            fetchData(currentPage);
        }
    }, [searchTerm, currentPage]);


    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const paginatedData = filteredInventory;



    const placeholderRows = Array(7)
        .fill({ uid: "", name: "", image: "" })
        .map((row, index) => ({ ...row, uid: `placeholder-${index}` }));
    const displayedData = loading ? placeholderRows : paginatedData;

    const [filtersApplied, setFiltersApplied] = useState(false);
    const [filtersModified, setFiltersModified] = useState(false);
    const [productName, setProductName] = useState("");
    const [productSku, setProductSku] = useState("");
    const [productId, setProductId] = useState("");
    const [categoryId, setCategoryId] = useState("");

    const handleFilterChange = (value, fieldName) => {
        if (fieldName === "productName") {
            setProductName(value);
            setSearchTerm(value);  // ✅ API trigger
        } else if (fieldName === "productSKU") {
            setProductSku(value);
            setSearchTerm(value);  // ✅ API trigger
        } else if (fieldName === "productCategory") {
            setCategoryId(value);
        } else if (fieldName === "productID") {
            setProductId(value);
            setSearchTerm(value);  // ✅ API trigger
        }
        setFiltersModified(true);
        setFiltersApplied(true);
    };



    const handleSearch = (searchTerm) => {
        const lowerSearch = searchTerm.toLowerCase();

        const filtered = inventory.filter(item =>
            item.product_name?.toLowerCase().includes(lowerSearch) ||
            item.sku?.toLowerCase().includes(lowerSearch) ||
            item.id?.toString().includes(lowerSearch)
        );

        setFilteredInventory(filtered);
        setCurrentPage(1); // Reset to first page after filtering
    };

    const handleSearch2 = (value) => {
        setSearchTerm(value);

        if (!value) {
            // agar search bar blank ho → pehla data wapas lao
            setInventory(originalData);
        } else {
            // filter data based on search term
            const filtered = originalData.filter((item) =>
                item?.itemName?.toLowerCase().includes(value.toLowerCase())
            );
            setInventory(filtered);
        }
    };



    useEffect(() => {
        if (searchTerm.trim() !== "") {
            const filtered = inventory.filter((item) =>
                item.product_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.sku?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.id?.toString().includes(searchTerm.toLowerCase())
            );
            setFilteredInventory(filtered);
            setCurrentPage(1); // ✅ search ke case me hi reset
        } else {
            setFilteredInventory(inventory); // ✅ pagination wale data ko as it is dikhao
        }
    }, [searchTerm, inventory]);


    const handleResetFilters = () => {
        setProductName("");
        setProductId("");
        setProductSku("");
        setCategoryId("");
        setSearchTerm("");
        setFiltersApplied(false);
        fetchData(currentPage); // ✅ Reset ke baad normal data
    };



    return (
        <div className="inventory_tab">
            <div className="inventory_tab_cummulations">
                <CummulativeBox name={"Total"} name2={"Products"} value={formatCurrencyValue(cummulations.totalProducts)} unit={"Products"} img={productImg} />
                <CummulativeBox name={"Active"} name2={"Products"} value={formatCurrencyValue(cummulations.activeProductsCount)} unit={"Products"} img={avaiProduct} />
                <CummulativeBox name={"Inactive"} name2={"Products"} value={formatCurrencyValue(cummulations.inactiveProductsCount)} unit={"Products"} img={inactProduct} />
                <CummulativeBox name={"Active"} name2={"Locations"} value={"9"} unit={"Locations"} img={locProduct} />
            </div>

           <div style={{display:"flex",alignItems:"flex-end",justifyContent:"end",width:"99%",margin:"20px 30px 20px 0",boxSizing:"border-box"}}>
             <SearchBar onSearch={handleSearch2} icon={searchIcon} />
           </div>


            {/* <div className="Filters-Section" style={{ width: "100%", marginLeft: 0, marginTop: "10px" }}>
                <Accordion allowZeroExpanded className="accordion">
                    <AccordionItem>
                        <AccordionItemHeading>
                            <AccordionItemButton>Filters</AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                            <div className="filter-row-01">
                                <div className="filter-label">Product Name</div>
                                <div className="filter-label">Product SKU</div>
                                <div className="filter-label">Product ID</div>
                            </div>

                            <div className="filter-row-02">
                                <InputField
                                    value={productName}
                                    name="productName"
                                    onChange={(e) =>
                                        handleFilterChange(e.target.value, "productName")
                                    }
                                    placeholder="Product Name"
                                />
                                <InputField
                                    value={productSku}
                                    name="productSKU"
                                    onChange={(e) =>
                                        handleFilterChange(e.target.value, "productSKU")
                                    }
                                    placeholder="Product SKU"
                                />
                                <InputField
                                    value={productId}
                                    name="productID"
                                    onChange={(e) =>
                                        handleFilterChange(e.target.value, "productID")
                                    }
                                    placeholder="Product ID"
                                />

                            </div>


                            <div className="filter-row-04">
                                {filtersApplied && (
                                    <CustomBtn
                                        label="Reset"
                                        withIcon={true}
                                        iconType="reset"
                                        className="ResetBtn-OrderPage"
                                        onClick={handleResetFilters}
                                        type="button"
                                    />
                                )}
                            </div>
                        </AccordionItemPanel>
                    </AccordionItem>
                </Accordion>
            </div> */}

            <div className="Orders-Table-Data" style={{ width: "100%", marginLeft: "0" }}>
                <div>
                    <DataTable
                        columns={OrdersColumns}
                        data={displayedData}
                        customStyles={customStyles}
                        // progressPending={loading}
                        persistTableHead
                        highlightOnHover
                        striped
                    />
                    <ElipticalPagenation
                        activePageIndex={currentPage}
                        totalPages={totalPages}
                        onPrevPage={handlePrevPage}
                        onNextPage={handleNextPage}
                        onPageChange={handlePageChange}
                    />
                </div>
            </div>
        </div>
    );
}
